<template>
  <div>
    <!-- Button aligned to the right -->
    <div class="d-flex justify-content-end mb-3">
      
      <b-button
        size="lg"
        variant="primary"
        class="ms-auto"
        :to="{ name: 'accounting-budget-add' }"
      >
        Add Budget
      </b-button>
    </div>
      <b-card>
        <b-table :items="budgetEntries" :fields="fields" responsive bordered>
          <template #cell(action)="row">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item :to="{ name: 'budget-edit', params: { id: row.item.id } }">
                <feather-icon icon="EditIcon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item :to="{ name: 'budget-report', params: { id: row.item.id } }">
                <feather-icon icon="BarChartIcon" class="mr-50" />
                <span>Variance Report</span>
              </b-dropdown-item>
              <b-dropdown-item @click="confirmDelete(row.item)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-card>
     
    </div>
  </template>
  
  <script>
import Swal from "sweetalert2";
  import { BTable, BButton, BCard,  BDropdown, BDropdownItem } from "bootstrap-vue";
  import { mapActions } from "vuex";
  export default {
    components: {
      BTable,
      BButton,
      BCard,
      BDropdown, 
      BDropdownItem
    },
    data() {
      return {
      
        fields: [
          { key: "category", label: "Name", sortable: true },
          { key: "actualAmount", label: "Actual Amount", sortable: true },
          { key: "budgetAmount", label: "Budget Amount", sortable: true },
          { key: "action", label: "Action" },
        ],
     
        budgetEntries: [
        ],
      };
    },
    methods: {
      ...mapActions("budgetModule", ["getBudgetListAction", "deleteBudgetAction"]),
      async fetchBudgetList() {
      try {
        Swal.fire({
          title: "Fetching Data...",
          text: "Please wait while we load the budget list.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const response = await this.getBudgetListAction();
        if (response) {
          this.budgetEntries = response.map((entry) => ({
            id: entry.id,
            category: entry.category,
            actualAmount: entry.actualAmount,
            budgetAmount: entry.budgetAmount,
          }));
        }
        Swal.close();
      } catch (error) {
        console.error("Error fetching budget list:", error);
        Swal.close();
      }
    },
    async confirmDelete(budget) {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
    customClass: {
      confirmButton: "custom-confirm-btn",
      cancelButton: "custom-cancel-btn",
    },
    buttonsStyling: false,
  });

  if (result.isConfirmed) {
    this.deleteBudget(budget.id);
  }
},

    async deleteBudget(budgetId) {
      try {
        const swalDeleting = Swal.fire({
      title: "Deleting...",
      text: "Please wait while we delete the budget.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await this.deleteBudgetAction(budgetId);
        Swal.close();

        Swal.fire({
      title: "Deleted!",
      text: "The budget has been deleted.",
      icon: "success",
      confirmButtonText: "OK",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await this.fetchBudgetList();
      }
    });
      } catch (error) {
        console.error("Error deleting budget:", error);
        Swal.close();

    // Show error message
    Swal.fire({
      title: "Error",
      text: "Failed to delete the budget. Please try again.",
      icon: "error",
      confirmButtonText: "OK",
    });

      }
    },
    },
    
    async mounted() {
    await this.fetchBudgetList();
  },
  };
  </script>
<style>
.swal2-actions .swal2-confirm {
  margin-right: 10px; 
}

.swal2-actions .swal2-cancel {
  margin-left: 10px; 
}

.custom-confirm-btn {
  background-color: #d9534f;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}

.custom-cancel-btn {
  background-color: #6c757d;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}
</style>

